import { Injectable } from '@angular/core';
import {
  AuthenticatedResponse,
  ForgotPasswordRequest,
  LoginByCodeRequest,
  LoginRequest,
  SetPasswordRequest,
  SignupRequest,
} from '@core/contracts/data-contracts';
import { environment } from '@src/environments/environment';
import { HttpAuth } from '@core/services/http-auth';
import { TOKEN_DATA_LOCALSTORAGE_KEY } from '@core/const/const';
import { Store } from '@ngrx/store';
import { UserActions } from '@state';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  private readonly url = `${environment.apiUrl}/api/Authentication`;

  constructor(
    private readonly httpAuth: HttpAuth,
    private readonly store: Store
  ) {}

  public get isAuthorized() {
    return !!localStorage.getItem(TOKEN_DATA_LOCALSTORAGE_KEY);
  }

  public loginWithToken(code: string) {
    const payload: LoginByCodeRequest = { code };
    return this.httpAuth.post<AuthenticatedResponse>(`${this.url}/login/code`, payload);
  }

  public login(payload: LoginRequest) {
    return this.httpAuth.post<AuthenticatedResponse>(`${this.url}/login`, payload);
  }

  public signup(payload: SignupRequest) {
    return this.httpAuth.post<AuthenticatedResponse>(`${this.url}/sign-up`, payload);
  }

  public logout() {
    this.store.dispatch(UserActions.signOut());
    localStorage.clear();
  }

  public forgotPassword(payload: ForgotPasswordRequest) {
    return this.httpAuth.post(`${this.url}/forgot-password`, payload);
  }

  public resetPassword(payload: SetPasswordRequest) {
    return this.httpAuth.post(`${this.url}/reset-password`, payload);
  }

  public cookieHandoff() {
    return this.httpAuth.post(`${this.url}/set-cookie`, null, { withCredentials: true });
  }
}
